import { render } from "./sti-dest-detail-reverse-scan.vue?vue&type=template&id=58510c41&ts=true"
import script from "./sti-dest-detail-reverse-scan.vue?vue&type=script&lang=ts"
export * from "./sti-dest-detail-reverse-scan.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__